/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FreelancerCharterResource
 */
export interface FreelancerCharterResource {
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerCharterResource
     */
    signed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerCharterResource
     */
    valid?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerCharterResource
     */
    invalidated?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof FreelancerCharterResource
     */
    invalidUntil?: Date;
}

/**
 * Check if a given object implements the FreelancerCharterResource interface.
 */
export function instanceOfFreelancerCharterResource(value: object): value is FreelancerCharterResource {
    return true;
}

export function FreelancerCharterResourceFromJSON(json: any): FreelancerCharterResource {
    return FreelancerCharterResourceFromJSONTyped(json, false);
}

export function FreelancerCharterResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerCharterResource {
    if (json == null) {
        return json;
    }
    return {
        
        'signed': json['signed'] == null ? undefined : json['signed'],
        'valid': json['valid'] == null ? undefined : json['valid'],
        'invalidated': json['invalidated'] == null ? undefined : json['invalidated'],
        'invalidUntil': json['invalidUntil'] == null ? undefined : (new Date(json['invalidUntil'])),
    };
}

export function FreelancerCharterResourceToJSON(value?: FreelancerCharterResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'signed': value['signed'],
        'valid': value['valid'],
        'invalidated': value['invalidated'],
        'invalidUntil': value['invalidUntil'] == null ? undefined : ((value['invalidUntil']).toISOString().substring(0,10)),
    };
}

